import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getPageByPspUrl} from '../api/contentstack/sdk/entry'
import {useParams} from 'react-router-dom'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const useGetEditorialPage = () => {
    const {locale} = useMultiSite()
    const {stack} = useContentstack()
    const params = useParams()
    const entryUrl = params.page ? `/${params.page}` : '/'

    const getPage = async () => {
        const response = await getPageByPspUrl({
            stack,
            contentTypeUid: 'page',
            url: entryUrl,
            locale: locale.alias,
        })
        return response && response[0] ? response[0] : null
    }

    const query = useQuery(['editorialPage', entryUrl], () => getPage())

    return query
}
